import axios from 'axios';
import _ from 'lodash'

// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    loaded : false,
    addNew : false,
    columns : [
      {
        key : "name",
        label : "Name",
        display : true
    },
    {
        key:"email",
        label: "E-Mail",
        display : true,
    }
    ],
    workingOn: [],
    isSavingNew : false,
    infinity : {
        clear: false,
        search : "",
        columns : ['name', 'email'],
        allLoaded : false,
        loading : false,
        loadingMore : false,
        take : 50,
    },
})

  // getters
  const getters = {
      id : (state) => (id) => {
        return state.list[state.list.findIndex(item => item.id == id)]
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        if(state.infinity.allLoaded == false && state.infinity.loading == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                var skip = state.list.length;
            }
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/commissionblocks", {params : {search : state.infinity.search, take: state.infinity.take, skip : skip, columns : state.infinity.columns}}).then((response) => {
                commit("set", response.data.data);

                commit("loaded", true);
                commit("infinityLoading", false);
            });
        }
    }
  }

  // mutations
  const mutations = {
      clean(state){
        state.list = [];
        state.infinity.allLoaded = false;
        state.loaded = false;
        state.workingOn = [];
      },
        addCompany(state, load){
            state.addNew = load;
        },
        store(state, company){
            state.list.unshift(company);
        },
      set(state, data){
          if(state.infinity.clear == true){
              state.data = [];
              state.allLoaded = false;
          }
          if(data == undefined || data.length < state.infinity.take){
              state.infinity.allLoaded = true;
          }
          state.list.push(...data);
          state.infinity.clear = false;
      },
      loaded(state, status){
          state.loaded = status;
      },
      isSavingNew(state, status){
          state.isSavingNew = status;
      },
        setSearch(state, search){
            state.infinity.loading = true;
            state.infinity.allLoaded = false;
            state.infinity.search = search;
            state.infinity.clear = true;
        },
        infinityLoading(state, status){
            state.infinity.loading = status;
        },
        setSearchValue(state, value){
            state.infinity.search = value;
        },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
